import Client from 'shopify-buy/index.unoptimized.umd'

// Production
const client = Client.buildClient({
  storefrontAccessToken: '83ce7d1f48fea93063d90fa10a8aa250',
  domain: 'heartonco.myshopify.com',
})

// Sandbox
// const client = Client.buildClient({
//   storefrontAccessToken: '0f7f9997cc5081b664882a0ae77b2c15',
//   domain: 'badpixel-sandbox.myshopify.com',
// })

export default client
